/** Namespace `reports` — wird befüllt während der Komponenten-Migration. */
export const reports = {
  de: {
    reports: {
      eyebrow: 'Praxis',
      title: 'Auswertungen',
      pageDescription: 'Termine, Angebote und Rechnungen im Überblick',
      range7d: '7 T',
      range30d: '30 T',
      range90d: '90 T',
      rangeYtd: 'YTD',
      weekPrefix: 'KW',
      legendCompleted: 'Abgeschlossen',
      legendPlanned: 'Geplant',
      legendLost: 'Ausgefallen',
      noApptData: 'Keine Termindaten im Zeitraum.',
      tooltipLost: '{{label}}: {{count}} ausgefallen',
      tooltipPlanned: '{{label}}: {{count}} geplant',
      tooltipCompleted: '{{label}}: {{count}} abgeschlossen',
      errorLoad: 'Auswertungen konnten nicht geladen werden.',
      // KPIs
      kpiAppointments: 'Termine',
      kpiAppointmentsSub: '{{count}} abgeschlossen',
      kpiOffers: 'Angebote',
      kpiInvoices: 'Rechnungen',
      kpiConversion: 'Angebot → Rechnung',
      kpiNoOffers: 'keine Angebote im Zeitraum',
      // Funnel
      funnelTitle: 'Patienten-Flow',
      funnelSubtitle: 'Vom Termin zur Rechnung — Conversion zwischen den Stufen',
      funnelBooked: 'Termine gebucht',
      funnelConfirmed: 'Bestätigt / geplant',
      funnelCompleted: 'Abgeschlossen',
      funnelOffer: 'Angebot erstellt',
      funnelInvoiced: 'Rechnung gestellt',
      // Time-series
      timeSeriesTitle: 'Termine im Zeitverlauf',
      // Top Behandlungen
      topProceduresTitle: 'Top Behandlungen',
      topProceduresSubtitle: 'Abgeschlossen im Zeitraum',
      noCompletedAppts: 'Keine abgeschlossenen Termine.',
    },
  },
  es: {
    reports: {
      eyebrow: 'Clínica',
      title: 'Informes',
      pageDescription: 'Resumen de citas, presupuestos y facturas',
      range7d: '7 d',
      range30d: '30 d',
      range90d: '90 d',
      rangeYtd: 'Año',
      weekPrefix: 'Sem.',
      legendCompleted: 'Completadas',
      legendPlanned: 'Planificadas',
      legendLost: 'Perdidas',
      noApptData: 'No hay datos de citas en el periodo.',
      tooltipLost: '{{label}}: {{count}} perdidas',
      tooltipPlanned: '{{label}}: {{count}} planificadas',
      tooltipCompleted: '{{label}}: {{count}} completadas',
      errorLoad: 'No se pudieron cargar los informes.',
      // KPIs
      kpiAppointments: 'Citas',
      kpiAppointmentsSub: '{{count}} completadas',
      kpiOffers: 'Presupuestos',
      kpiInvoices: 'Facturas',
      kpiConversion: 'Presupuesto → Factura',
      kpiNoOffers: 'sin presupuestos en el periodo',
      // Embudo
      funnelTitle: 'Flujo de pacientes',
      funnelSubtitle: 'De la cita a la factura: conversión entre etapas',
      funnelBooked: 'Citas reservadas',
      funnelConfirmed: 'Confirmadas / planificadas',
      funnelCompleted: 'Completadas',
      funnelOffer: 'Presupuesto creado',
      funnelInvoiced: 'Factura emitida',
      // Serie temporal
      timeSeriesTitle: 'Citas a lo largo del tiempo',
      // Tratamientos principales
      topProceduresTitle: 'Tratamientos principales',
      topProceduresSubtitle: 'Completados en el periodo',
      noCompletedAppts: 'No hay citas completadas.',
    },
  },
};
